import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// CONFIGS

// INTERFACES
import { IStock } from '../../../../rfq/interfaces/rfq-stock.interface';

// SERVICES
import { EnvironmentUtilService } from '../../util/environment-util.service';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class RfqStockLocationApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getById(data :{
    id :number;
    params ?:{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { id, params } = data;

    return this.apiService.get(
      `${this.environment.urlV2}/rfq-stock-locations/${id}`,
      { params },
    );
  }

  updateQuantity(stockLocation :IStock) :Observable<any> {
    const { id } = stockLocation;

    return this.apiService.post({
      path: `${this.environment.urlV2}/rfq-stock-locations/${id}`,
      body: stockLocation,
    });
  }

  moveSkuToLocation(payload :{
    rfqStockLocationIds :number[];
    sourceLocationId :number;
    destinationLocationId :number;
    quantity :number;
  }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV1}/inventory/transfer-skus-location`,
      body: payload,
    });
  }

  getRfqsByLocationId(data :{
    params ?:{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { params = {} } = data;

    return this.apiService.get(`${this.environment.urlV2}/rfq-stock-locations`, {
      params,
    });
  }
}
